/* import __COLOCATED_TEMPLATE__ from './conversation-resumed.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationResumed from 'embercom/objects/inbox/renderable/conversation-resumed';
interface ConversationResumedPart extends RenderablePart {
  renderableData: ConversationResumed;
}

interface Args {
  part: ConversationResumedPart;
}

interface Signature {
  Args: Args;
}

export default class ConversationResumedComponent extends Component<Signature> {
  @service declare session: Session;

  get renderableData() {
    return this.args.part.renderableData;
  }

  get adminSummary() {
    return this.renderableData.adminSummary;
  }

  get isCurrentUser() {
    return this.adminSummary.id === this.session.teammate.id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationResumed': typeof ConversationResumedComponent;
    'inbox2/conversation-stream/event-parts/conversation-resumed': typeof ConversationResumedComponent;
  }
}
